import { getEnumValues } from '../common';
import { compact } from 'lodash';
import { type Timestamp } from '../firebase/firestore/adaptor';
import { ISODateType, Timezone } from './timezone';
import { DAY_OF_WEEK_FORMAT } from './date-time-formatting';
import { toMomentTz } from './time';
import * as moment from 'moment-timezone';

export enum DayOfWeek {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

export enum ISODayOfWeek {
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
  Sunday = 7,
}

export type DayOfWeekShort =
  | 'Sun'
  | 'Mon'
  | 'Tue'
  | 'Wed'
  | 'Thu'
  | 'Fri'
  | 'Sat';

export type HourOfDay =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23;

export const DAYS_OF_WEEK: DayOfWeek[] = getEnumValues(DayOfWeek);
export const WEEKEND_DAYS: DayOfWeek[] = [DayOfWeek.Saturday, DayOfWeek.Sunday];
export const WEEK_DAYS: DayOfWeek[] = DAYS_OF_WEEK.filter(
  (day) => !WEEKEND_DAYS.includes(day)
);

/**
 * Compares two collections of days as sets, ignoring order and duplicates.
 */
export function hasSameDays(days: DayOfWeek[], other: DayOfWeek[]): boolean {
  const unique = new Set(days);
  const otherUnique = new Set(other);
  return (
    unique.size === otherUnique.size &&
    [...unique].every((day) => otherUnique.has(day))
  );
}

const tempDaysOfWeek = getEnumValues(DayOfWeek);
tempDaysOfWeek.unshift(...compact([tempDaysOfWeek.pop()]));
export const CALENDAR_DAYS_OF_WEEK: DayOfWeek[] = tempDaysOfWeek;

export function toDayOfWeek(
  date: moment.Moment | Timestamp | Date | ISODateType,
  timezone: Timezone
): DayOfWeek {
  return toMomentTz(date, timezone)
    .format(DAY_OF_WEEK_FORMAT)
    .toLowerCase() as DayOfWeek;
}
